const Modes = {
	Create: 'create',
	Update: 'update',
	Republish: 'republish',
	Read: 'read',
};

export { Modes };
